<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">{{$t('新增')}}</el-button>

    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :request-params="{type: 'lead'}"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" width="50" :label="$t('序号')" fixed />
        <el-table-column prop="phone" :label="$t('图片')" fixed>
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.photo" ></preview-img>
          </template>
        </el-table-column>
        <el-table-column prop="priority" :label="$t('优先级')"/>
        <el-table-column fixed="right" :label="$t('操作')" width="130">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <lead-page-add-or-edit ref="addOrEdit" :is-edit="isEdit" :data="currentRow" @save="handleAddOrEditSubmit"></lead-page-add-or-edit>
    </template>
  </ankh-list>
</template>

<script>
import AnkhList from "@/components/list/AnkhList.vue";
import TableList from "@/components/table-list/TableList.vue";
import {request, requestByTip} from "@/config/request";
import LeadPageAddOrEdit from "@/components/lead-page/LeadPageAddOrEdit.vue";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "landing-page-list" ,
  components: {PreviewImg, LeadPageAddOrEdit, TableList, AnkhList},
  data(){
    return{
      searchForm: {},
      tableData: [],
      selection: [],
      isEdit: false,
      currentRow: {}
    }
  },
  methods:{
    // 新增/编辑提交
    async handleAddOrEditSubmit(data) {
      try {
        data.type = "lead";
        if(this.isEdit) data.code = this.currentRow.code;
        const action = this.$api.banner[this.isEdit ? "update" : "add"];
        await request(action, data);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
        this.$refs.addOrEdit.showDialog = false;
      } catch (e) {
        console.log(e);
      }
    },

    // 打开新增/编辑弹窗
    handleShowFormDialog(row) {
      if(row) {
        this.isEdit = true;
        this.currentRow = {...row};
      } else {
        this.isEdit = false;
      }
      this.$refs.addOrEdit.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.banner.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.banner.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
  }
</script>

<style scoped>

</style>
